import { Avatar } from "components/Avatar";
import { Grid } from "components/Grid";
import { PR, translate } from "shared/translate";
import { SMALL } from "shared/constants";
import { useRouter } from "next/router";

export const ResearcherGrid = ({ researchers }) => {
  const { locale } = useRouter();

  return (
    <Grid size={SMALL}>
      {(researchers || []).map((props, index) => (
        <Avatar
          key={index}
          badge={index === 0 ? translate(PR, locale) : null}
          {...props}
        />
      ))}
    </Grid>
  );
};
